import {
  CreateVendorRequest,
  UpdateVendorRequest,
  UpdateVendorStatusRequest,
} from '../../interface/request/VendorRequest'
import { GenericAPIResponse } from '../../interface/response/CommonResponse'
import { VendorData, VendorInfo } from '../../interface/response/VendorResponse'
import { REQUEST_STATUS } from '../../utils/constants/RequestCommonConstant'
import { apiService } from '../apiService'

export const vendorApiService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getVendors: builder.query({
      query: (args: object) => {
        return {
          url: `/Vendor/GetVendors`,
          params: args,
        }
      },
      transformResponse: (response: { data: VendorData[] }) => {
        return response?.data
      },
      providesTags: ['VendorList'],
    }),
    getVendorDetailsByCode: builder.query({
      query: (VendorCode: string) => {
        return {
          url: `/Vendor/GetVendorDetailsByCode`,
          params: {
            VendorCode: VendorCode,
          },
        }
      },
      transformResponse: (response: { data: VendorInfo }) => {
        return response?.data
      },
      providesTags: ['GetVendorByCode'],
    }),
    addVendor: builder.mutation({
      query: (queryData: CreateVendorRequest) => {
        return {
          url: `/Vendor/createVendor`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['VendorList'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
    updateVendor: builder.mutation({
      query: (queryData: UpdateVendorRequest) => {
        return {
          url: `/Vendor/updateVendor`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['VendorList', 'GetVendorByCode'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
    updateVendorStatus: builder.mutation({
      query: (queryData: UpdateVendorStatusRequest) => {
        return {
          url: `/Vendor/updateVendorStatus`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['VendorList', 'GetVendorByCode'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
    getAssociatedVendors: builder.query({
      query: () => {
        return {
          url: `/Vendor/GetVendors?status=${REQUEST_STATUS.APPROVED}`,
        }
      },
      transformResponse: (response: { data: VendorData[] }) => {
        return response?.data
      },
      providesTags: ['AssociatedVendorList'],
    }),
  }),
})

export const {
  useLazyGetVendorsQuery,
  useLazyGetVendorDetailsByCodeQuery,
  useAddVendorMutation,
  useUpdateVendorMutation,
  useUpdateVendorStatusMutation,
  useLazyGetAssociatedVendorsQuery,
} = vendorApiService
